module.exports = __webpack_public_path__ + "static/plug-in-dimmer-8174d49ace18bca76337fbb3b574f1b0.png";